<div class="detail-loader">
  <div class="content">
    <content-loader viewBox="0 0 100 28">
      <svg:rect x="0" y="0" rx="0" ry="0" width="30" height="28" />
      <svg:rect x="31" y="1" rx="0" ry="0" width="25" height="5" />
      <svg:rect x="31" y="7" rx="0" ry="0" width="30" height="2" />
      <svg:rect x="31" y="10" rx="0" ry="0" width="25" height="2" />
      <svg:rect x="31" y="13" rx="0" ry="0" width="20" height="2" />

      <svg:rect x="85" y="1" rx="0" ry="0" width="6" height="6" />
      <svg:rect x="85" y="8" rx="0" ry="0" width="6" height="0.5" />
      <svg:rect x="85" y="9.5" rx="0" ry="0" width="6" height="1" />
      <svg:rect x="85" y="11.5" rx="0" ry="0" width="6" height="5" />
    </content-loader>
  </div>
</div>
